import { forEach } from 'lodash';

export default class TableResults {
  constructor() {
    this.init();
    window.uRefreshTableResultsLinks = this.init.bind(this);
  }

  init() {
    this.rows = document.querySelectorAll('[data-results="root"] [data-results="row"]');
    this.bind();
  }

  bind() {
    forEach(this.rows, (row) => {
      row.addEventListener('click', function() {
        const el = this.querySelector('a');
        const href = el.getAttribute('href');

        if (el.getAttribute('target') === '_blank') {
          window.open(href, '');
        } else {
          window.location = href;
        }
      });
    });
  }
}
